<template>
  <div class="w-100 h-100 m-0" style="padding: 32px; background: #FFFFFF;">
    <div class="d-flex flex-column" style="gap: 40px;">
      <div class="m-0 p-0 acry-page-title justify-content-center">チケット一覧</div>

      <!-- パンクズ -->
      <div class="d-flex" style="gap: 14px; font-size: 13px;">
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnTop()" >
          ACRY TICKET TOP
        </div>
        <div>
          ＞
        </div>
        <div>
          チケット一覧
        </div>
      </div>

      <!-- コンテンツ -->
      <div class="d-flex flex-column">
        <div class="m-0 p-0 acrypro-text-main-bold text-start" style="height: 35px; border-bottom: solid 1px #8C9BC6;">
          チケット発行履歴リスト
        </div>

        <div class="d-flex flex-wrap" style="gap: 8px;">
          <div v-for="(event, key) in this.$store.state.acrylicTicketCouponManager.eventList" :key="key" class="event-cell d-flex flex-column" @click="onClickEdit(event)">
            <div class="event-name" style="height: 20px; font-size 15px;">
              {{event.name}}
            </div>
            <div class="event-status" :style="getStatusColor(event)">
              {{ getStatusText(event) }}
            </div>
            <img v-if="event.preview" class="event-image" :src="event.preview">
            <div v-if="!event.preview" class="event-image d-flex flex-column justify-content-center" style="background: #EEECF1; font-size: 16px; color: #BDBDBD;">
              <div>
                No
              </div>
              <div>
                image
              </div>
            </div>
          </div>
        </div>
      </div>




    </div>
  </div>
</template>

<script>
import { CenterViewState } from "@/js/Const.js";
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
import { FileKit } from "@/js/FileKit.js";

export default {
  name: "CenterViewEventTicketIssueHistory_Ap",
  props: {},
  data: function () {
    return {
      issueData:[],

    };
  },
  computed: {
    getStatusColor() {
      return function (event) {
        return {
          "background": (event.configured)?"#595959":"#BC6665",
        };
      };
    },
  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");
    this.$store.commit("showLoading");

    await this.$store.state.acrylicTicketCouponManager.update().catch(() => {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
    });
    await this.$store.state.acrylicTicketCouponManager.resetEditData();

    this.$store.commit("hideLoading");
  },
  components: {
    
  },
  methods: {
    getStatusText(event){
      if( event.configured ){
        if( this.$store.state.acrylicTicketCouponManager.isIssueTicketEvent(event.docId) ){
          return "有効コードあり";
        }else{
          return "有効コードなし";
        }
      }else{
        return "登録再開する";
      }
    },

    onClickReturnTop(){
      this.$store.commit("setCenterViewState", CenterViewState.EventManagement);
    },


    async onClickEdit(event){
      this.$store.commit("resetEventCreateData");
      this.$store.commit("showLoading");

      console.log(event);

      this.$store.commit("setEventCreateEventSelectSize", event.size);
      this.$store.commit("setEventCreateEventUserEdit", event.isUserEdit);
      this.$store.commit("setEventCreateEventIsShippingFee", event.isShippingFee);

      // 編集を行うために既存のデータを設定していく
      this.$store.commit("setEventCreateEventIsEdit", true);
      this.$store.commit("setEventCreateDocId", event.docId);
      this.$store.commit("setEventCreateEventName", event.name);
      this.$store.commit("setEventCreateEventIssuerName", event.issuerName);
      this.$store.commit("setEventCreateEventFolderName", event.folderName);

      if( event.design ){
        const designFile = await FirebaseCommon.downloadPngImage(event.design);
        this.$store.commit("setEventCreateDesignData", new FileKit(designFile));
      }

      if( event.cutline ){
        const cutlineFile = await FirebaseCommon.downloadPngImage(event.cutline);
        const cutlineFileKit = new FileKit(cutlineFile)
        this.$store.commit("setEventCreateCutlineData", cutlineFileKit);
        this.$store.commit("setEventCreateCutlineImageURL", cutlineFileKit.fileURL);
      }

      if( event.nonEditable ){
        const nonEditableFile = await FirebaseCommon.downloadPngImage(event.nonEditable);
        this.$store.commit("setEventCreateNonEditableData", new FileKit(nonEditableFile));
      }

      if( event.banner1 ){
        const bannerFile = await FirebaseCommon.downloadPngImage(event.banner1);
        this.$store.commit("setEventCreateBannerData1", new FileKit(bannerFile));
      }

      if( event.banner2 ){
        const bannerFile = await FirebaseCommon.downloadPngImage(event.banner2);
        this.$store.commit("setEventCreateBannerData2", new FileKit(bannerFile));
      }

      if( event.preview ){
        const previewFile = await FirebaseCommon.downloadPngImage(event.preview);
        this.$store.commit("setEventCreatePreviewData", new FileKit(previewFile));
      }

      // 

      this.$store.state.acrylicTicketCouponManager.selectEditSetting = event;

      // 一旦完成しているかどうかで遷移先を変更
      console.log(event);
      if( event.configured ){
        this.$store.commit("setCenterViewState", CenterViewState.EventEdit);
      }else{
        this.$store.commit("setCenterViewState", CenterViewState.EventCreate);
      }

    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.event-cell{
  height: 436px;
  width: 240px;
  padding: 16px;
  gap: 8px;
  border: solid 1px #D1D5DB;
  cursor: pointer;
}
.event-name{
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-status{
  color: #FFFFFF;
  height: 30px;
  width: 100%;
  border-radius: 20px;
}
.event-image{
  height: 338px;
  width: 100%;
  object-fit: contain;
}
</style>


